(function (ng) {
    // Make an element 'sticky'
    ng.module('evo.Compare.Directives').directive('affix', ['$window', function ($window) {
        return {
            restrict: 'A',
            scope: {
                // The top offset at which to begin sticking
                offset: '=affix'
            },
            link: function ($scope, $el) {
                var $element = ng.element($el),
                    $parent = $element.parent(),
                    offsetTop = $element.offset().top,
                    $win = ng.element($window),
                    $dummy = ng.element('<div />'),
                    fixed = false;

                // Watch the current scroll position and add / remove affix requirements
                $win.on('scroll', function () {
                    var top = $win.scrollTop();

                    if (!fixed)
                        offsetTop = $element.offset().top;

                    if ((offsetTop - top) <= ($scope.offset || 0)) {
                        $dummy.height($element.height());
                        if (!fixed)
                            $parent.prepend($dummy);

                        $element.css({
                            'position': 'fixed',
                            'top': ($scope.offset || 0) + 'px'
                        });
                        fixed = true;
                    }
                    else {
                        $dummy.remove();
                        $element.removeAttr('style');
                        fixed = false;
                    }
                });
            }
        };
    }]);
})(angular);